<InactivityModal />

<!-- App shell: navbar + sidebar fixed; only content scrolls -->
<div class="vh-100 d-flex flex-column bg-gray overflow-hidden">

  <!-- Navbar (same component & behavior) -->
  <Navbar
    @sidebar-toggle="toggleSidebar"
    class="navbar navbar-expand-lg sticky-top bg-white border-bottom w-100 p-0 m-0">
  </Navbar>

<!-- Main area below navbar fills remaining height -->
<div class="container-fluid flex-grow-1 overflow-hidden">
  <div class="row h-100">

    <!-- Sidebar column (same Sidebar component; no scrolling) -->
    <div class="col-auto bg-white h-100 d-none d-lg-block rounded-end mt-2">
      <div class="mt-2">
        <Sidebar ref="sidebar"></Sidebar>
      </div>
    </div>

    <!-- Content column (the ONLY scrollable area) -->
    <div class="col h-100 overflow-auto mt-2">

      <!-- Forms card -->
      <div class="visitor-card shadow border-primary">
        <div class="card-body bg-white">

          <!-- Actions header (sticky within scrollable content) -->
          <div class="d-flex justify-content-start align-items-center sticky-top">
            <button
              class="btn btn-primary btn-sm rounded-3 shadow-sm lh-sm"
              data-bs-toggle="modal"
              data-bs-target="#create_form"
            >
              <span class="small text-xxs d-flex align-items-center gap-1">
                <i class="bx bx-plus fs-6"></i>
                Create Form
              </span>
            </button>
            <button v-if="profile_tab_id"
            class="btn btn-primary btn-sm rounded-3 shadow-sm lh-sm ms-2"
            :disabled="!selected_forms.length"
            @click="assign_selected_form"
          >
          <span class="small text-xxs d-flex align-items-center gap-1">

            <i class="bi bi-diagram-3 "></i> Assign Selected Forms
          </span>
          </button>
          </div>

          <!-- Table -->
          <div class="table-responsive mt-2">
            <div v-show="isLoading" class="text-center py-5 w-100">
              <div class="spinner-border text-secondary" role="status">
                <span class="visually-hidden">Loading...</span>
              </div>
              <p class="mt-2 mb-0 text-muted text-xxs">Loading Form List...</p>
            </div>
            <div v-show="!isLoading">
              <table id="forms_table" class="table align-middle table-striped table-borderless mb-0">
                <!-- Header styling mirrors Create Portal -->
                <thead class="text-uppercase btn-primary text-white">
                  <tr>
                    <th class="text-xxs fw-light text-center" v-if="profile_tab_id">
                      <input type="checkbox" v-model="all_selected_forms" @change="toggle_selected_all_forms" />
                    </th>
                    <th class="text-xxs fw-light text-center">No.</th>
                    <th class="text-xxs fw-light">Form Name</th>
                    <th class="text-xxs fw-light">Description</th>
                    <th class="text-xxs fw-light text-center">Actions</th>
                  </tr>
                </thead>

                <tbody class="text-black">
                  <tr
                    v-for="(form, index) in forms"
                    :key="form.id"
                    class="border-bottom text-xxs"
                  >
                    <!-- Checkbox -->
                    <td class="text-center"v-if="profile_tab_id">
                      <input type="checkbox" :value="form.id" v-model="selected_forms" />
                    </td>

                    <!-- Number -->
                    <td class="text-center">
                      <span class="badge rounded-pill bg-primary text-white fw-normal px-2 py-1 text-xxs">
                        {{ index + 1 }}
                      </span>
                    </td>

                    <!-- Form Name -->
                    <td>
                      <div class="text-xxs fw-500">{{ form.name }}</div>
                    </td>

                    <!-- Description -->
                    <td>
                      <div class="text-muted text-xxs">{{ form.description || '—' }}</div>
                    </td>

                    <!-- Actions -->
                    <td class="text-center">
                      <div class="d-flex justify-content-center gap-1">
                        <router-link :to="'/create_section/' + form.id">
                          <button class="btn btn-light btn-sm rounded-3 text-success border text-xxs shadow-sm">
                            <i class="bi bi-pencil-square me-1"></i> Manage
                          </button>
                        </router-link>

                        <button
                          type="button"
                          class="btn btn-light btn-sm rounded-3 text-primary border text-xxs shadow-sm"
                          data-bs-toggle="modal"
                          data-bs-target="#assignQuestionsModal"
                          @click="prepareAssignQuestions(form)"
                        >
                          <i class="bi bi-diagram-3 me-1"></i> Assign
                        </button>

                        <button
                          class="btn btn-light btn-sm rounded-3 text-danger border text-xxs shadow-sm"
                          @click="delete_form(form.id)"
                        >
                          <i class="bi bi-trash me-1"></i> Delete
                        </button>
                      </div>
                    </td>
                  </tr>
                </tbody>

              </table>
            </div>
            </div>
 <!-- /table-responsive -->

        </div> <!-- /card-body -->
      </div> <!-- /visitor-card -->

    </div> <!-- /col content -->

  </div> <!-- /row -->
</div> <!-- /container-fluid -->


  <!-- Modal for Creating Form -->
  <div class="modal fade" id="create_form" tabindex="-1" aria-labelledby="createFormLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
        <div class="modal-content">
          <div class="modal-header bg-primary text-white position-relative">
                  <p class="modal-title text-xxs fw-500">Create Form</p>
                  <!-- Close button on the end with white "X" -->
                  <button
                    type="button"
                    class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
                    data-bs-dismiss="modal"
                    aria-label="Close">
                  </button>
              </div>
              <form @submit.prevent="createForm">
                  <div class="modal-body">
                      <div class="mb-3">
                          <label for="form_name" class="form-label text-xxs fw-500">
                              Form Name <span class="text-danger">*</span>
                          </label>
                          <input type="text" class="form-control rounded-5 text-xxs" id="form_name"
                              v-model="form_name" placeholder="Enter form name">
                          <p v-if="errors.form_name" class="text-danger text-xxs">{{ errors.form_name }}</p>
                      </div>

                      <div class="mb-3">
                          <label for="form_description" class="form-label text-xxs fw-500">Description</label>
                          <textarea class="form-control rounded-5 text-xxs" id="form_description"
                              v-model="form_description" placeholder="Enter description"></textarea>
                      </div>
                  </div>
                  <div class="modal-footer">
                      <button type="submit" class="btn btn-primary text-xxs rounded-5">Create Form</button>
                  </div>
              </form>
          </div>
      </div>
  </div>

  <div class="modal fade" id="assignQuestionsModal" tabindex="-1" aria-labelledby="assignQuestionsModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg modal-dialog-scrollable modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header bg-primary text-white position-relative">
          <h5 v-if="is_unassigning" class="modal-title text-white text-xxs fw-500" id="assignQuestionsModalLabel">
            Unassign Questions
          </h5>
          <h5 v-else class="modal-title text-white text-xxs fw-500" id="assignQuestionsModalLabel">
            Assign/Unassign Questions
          </h5>
          <!-- Close button on the end with white "X" -->
          <button
            type="button"
            class="btn-close btn-close-white position-absolute end-0 top-50 translate-middle-y me-2"
            data-bs-dismiss="modal"
            aria-label="Close">
          </button>
        </div>
       <div class="modal-body">
  <!-- Show error message if exists -->
      <p v-if="form_error_message" class="text-danger text-xxs mb-2">
        {{ form_error_message }}
      </p>

      <!-- Show instructions & checkboxes only if no message -->
      <div v-else>
        <p class="text-xxs">
          Select the profile types to assign the selected questions:
        </p>

        <div
          class="form-check form-check-sm text-xxs" v-for="profile in profile_types" :key="profile.id"
        >
          <input
            class="form-check-input"
            type="checkbox"  :id="'profile_' + profile.id":value="profile.id"v-model="selected_profiles"
          />
          <label
            class="form-check-label text-xxs"
            :for="'profile_' + profile.id"
          >
            {{ profile.name }}
          </label>
        </div>
      </div>
    </div>


  
        <div class="modal-footer">
          <button
            v-if="is_unassigning"
            type="button"
            class="btn btn-primary text-xxs rounded-5"
            @click="filter_assigned_questions"
          >
            Continue
          </button>
          <button
            v-else
            type="button"
            class="btn btn-primary text-xxs rounded-5"
            @click="assignQuestions"
          >
            Save
          </button>
        </div>
      </div>
    </div>
  </div>
</div>
